const {Component} = require("react");
const PropTypes = require("prop-types");

class List extends Component {

	static get propTypes() {
		return {
			items: PropTypes.array
		};
	}

	static get defaultProps() {
		return {
			items: []
		};
	}

	constructor(props) {
		super(props);

		this.state = {
			items: props.items
		};
	}

	componentWillReceiveProps(nextProps) {
		if (nextProps.items instanceof Array) {
			this.setItems(nextProps.items);
		}
	}

	setItems(items) {
		this.setState({items: items});
		return this;
	}

	getItems() {
		return this.state.items;
	}

	get className() {
		return "list";
	}

	renderItem(item, key) {
		/// extend this ...
	}

	renderItems() {
		return this.state.items.map((item, i) => {
			return this.renderItem(item, i);
		});
	}

	render() {
		return (
			<div className={this.className}>{this.renderItems()}</div>
		);
	}

}

module.exports = List;